type Props = {
    data: any[];
};

const TopProductsCard = ({ data }: Props) => {
    return (
        <div className="bg-white p-5 rounded-2xl shadow-sm">
            <h2 className="text-lg font-semibold mb-4">Top Products</h2>

            <div className="flex flex-col gap-3">
                {data?.map((item, i) => (
                    <div key={i} className="flex justify-between text-sm border-b pb-2">
                        <span>{item.productName}</span>
                        <span className="font-semibold">
                            QAR {item.totalSales}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TopProductsCard;